export function ErrorBeep(){
    const audioContext = new (window.AudioContext || window.webkitAudioContext)();

    const oscillator = audioContext.createOscillator();
    const gainNode = audioContext.createGain();

    oscillator.connect(gainNode);
    gainNode.connect(audioContext.destination);

    oscillator.frequency.value = 1000; // Frecuencia del pitido en Hz
    oscillator.type = "sine";

    gainNode.gain.value = 1; // Volumen

    oscillator.start();

    setTimeout(() => {
        oscillator.stop();
        audioContext.close();
    }, 1000); // Duración: 200 ms
};

// const pitido = () => {
//     const audio = new Audio("/pitido.mp3");
//     audio.play();
// };